export function initializeBarCode() {
    const eanHolders = document.querySelectorAll(".js-product-ean-code-holder");

    if (!eanHolders.length) {
        return;
    }

    import("jsbarcode/dist/barcodes/JsBarcode.ean-upc.min.js").then(() => {
        eanHolders.forEach((eanHolderEl) => {
            if (eanHolderEl.classList.contains("is-initialized")) {
                return;
            }

            const eanEl = eanHolderEl.querySelector(".js-product-ean-code");
            const eanErrorEl = eanHolderEl.querySelector(".js-product-ean-code-error");

            if (!eanEl) return;

            const eanCode = eanEl.getAttribute("data-code");
            if (!eanCode) return;

            try {
                JsBarcode(eanEl, eanCode, {
                    width: .8,
                    height: 16,
                    lineColor: "#000",
                    background: "transparent",
                    flat: true,
                    displayValue: true,
                    margin: 0,
                    fontSize: 10,                      
                });

                eanHolderEl.classList.add("is-initialized");
            } catch (e) {
                console.error("ProductEan: Error while initializing barcode", e);

                eanEl.classList.add("hidden");
                eanHolderEl.classList.add("has-error");
                //eanErrorEl.classList.remove("hidden");
                //eanErrorEl.innerHTML = e?.message || e;
            }
        });
    });
}